export const analyticsConstants = {
    ANALYTICS_CONVERSION_REQUEST: 'ANALYTICS_CONVERSION_REQUEST',
    ANALYTICS_CONVERSION_SUCCESS: 'ANALYTICS_CONVERSION_SUCCESS',
    ANALYTICS_CONVERSION_FAILURE: 'ANALYTICS_CONVERSION_FAILURE',

    ANALYTICS_REVIEWS_REQUEST: 'ANALYTICS_REVIEWS_REQUEST',
    ANALYTICS_REVIEWS_SUCCESS: 'ANALYTICS_REVIEWS_SUCCESS',
    ANALYTICS_REVIEWS_FAILURE: 'ANALYTICS_REVIEWS_FAILURE',

    ANALYTICS_FEEDBACK_REQUEST: 'ANALYTICS_FEEDBACK_REQUEST',
    ANALYTICS_FEEDBACK_SUCCESS: 'ANALYTICS_FEEDBACK_SUCCESS',
    ANALYTICS_FEEDBACK_FAILURE: 'ANALYTICS_FEEDBACK_FAILURE',

    ANALYTICS_CONVERSATIONS_SUCCESS: 'ANALYTICS_CONVERSATIONS_SUCCESS',
    ANALYTICS_CONVERSATIONS_FAILURE: 'ANALYTICS_CONVERSATIONS_FAILURE',

    ANALYTICS_SOCIAL_POSTS_REQUEST: 'ANALYTICS_SOCIAL_POSTS_REQUEST',
    ANALYTICS_SOCIAL_POSTS_SUCCESS: 'ANALYTICS_SOCIAL_POSTS_SUCCESS',
    ANALYTICS_SOCIAL_POSTS_FAILURE: 'ANALYTICS_SOCIAL_POSTS_FAILURE',

    ANALYTICS_PRESENCE_REQUEST: 'ANALYTICS_PRESENCE_REQUEST',
    ANALYTICS_PRESENCE_SUCCESS: 'ANALYTICS_PRESENCE_SUCCESS',
    ANALYTICS_PRESENCE_FAILURE: 'ANALYTICS_PRESENCE_FAILURE',

    ANALYTICS_OPERATIONAL_INSIGHTS_REQUEST: 'ANALYTICS_OPERATIONAL_INSIGHTS_REQUEST',
    ANALYTICS_OPERATIONAL_INSIGHTS_SUCCESS: 'ANALYTICS_OPERATIONAL_INSIGHTS_SUCCESS',
    ANALYTICS_OPERATIONAL_INSIGHTS_FAILURE: 'ANALYTICS_OPERATIONAL_INSIGHTS_FAILURE',

    ANALYTICS_VISIBILITY_SUMMARY_REQUEST: 'ANALYTICS_VISIBILITY_SUMMARY_REQUEST',
    ANALYTICS_VISIBILITY_SUMMARY_SUCCESS: 'ANALYTICS_VISIBILITY_SUMMARY_SUCCESS',
    ANALYTICS_VISIBILITY_SUMMARY_FAILURE: 'ANALYTICS_VISIBILITY_SUMMARY_FAILURE',

    ANALYTICS_VISIBILITY_LOCATIONS_REQUEST: 'ANALYTICS_VISIBILITY_LOCATIONS_REQUEST',
    ANALYTICS_VISIBILITY_LOCATIONS_SUCCESS: 'ANALYTICS_VISIBILITY_LOCATIONS_SUCCESS',
    ANALYTICS_VISIBILITY_LOCATIONS_FAILURE: 'ANALYTICS_VISIBILITY_LOCATIONS_FAILURE',

    ANALYTICS_VISIBILITY_AUTOSCAN_SET: 'ANALYTICS_VISIBILITY_AUTOSCAN_SET',

    ANALYTICS_VISIBILITY_DETAIL_REQUEST: 'ANALYTICS_VISIBILITY_DETAIL_REQUEST',
    ANALYTICS_VISIBILITY_DETAIL_SUCCESS: 'ANALYTICS_VISIBILITY_DETAIL_SUCCESS',
    ANALYTICS_VISIBILITY_DETAIL_FAILURE: 'ANALYTICS_VISIBILITY_DETAIL_FAILURE',
};

export const TREND_TYPE = {
    CONVERSATIONS: 0,
    IMPRESSIONS: 1,
    REACH: 2,
    ENGAGEMENTS: 3,
    PRESENCE_VIEWS: 4,
    PRESENCE_ENGAGEMENTS: 5,
};

export const GroupByFilter = {
    Days: 0,
    Weeks: 1,
    Months: 2,
    Years: 3,
};
